import React, { Component } from 'react'
import Select from 'react-select'
import Dropzone from 'react-dropzone'

class CareersForm extends Component {

  state = {
    register: true,
    resumes: [],
    cover_letters: [],
    isSubmitting: false,
  }

  constructor(props) {
    super(props)
    this.form = React.createRef()
    this.jobs = []
    this.props.jobs?.map((el, i) => (
      this.jobs?.push({
        label: el.title,
        value: el.title
      })
    ))
  }

  onDropResume = (resumes) => {
    this.setState({
      resumes: resumes,
      resume: resumes[0]
    })
  }

  onDropCover = (cover_letters) => {
    this.setState({
      cover_letters: cover_letters,
      cover_letter: cover_letters[0]
    })
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSelectChange = (option, field) => {
    let state = {}
    switch (field && field.action) {
      case 'select-option':
        state[field.name] = option.value
        this.setState(state)
        break
      default:
        let { name, value } = option.currentTarget
        state[name] = value
        this.setState(state)
        break
    }
  }

  handleSubmit = e => {
    e.preventDefault()

    if (!this.form.current.checkValidity()) return false

    // Disable the submit button
    this.setState({ isSubmitting: true })

    const formData = new FormData(this.form.current);

    formData.append('resumes', this.state.resumes[0])
    formData.append('cover_letters', this.state.cover_letters[0])


    // https://zapier.com/editor/205062949/published/205066421/sample
    fetch("https://hooks.zapier.com/hooks/catch/2181815/3526foi/", {
      method: "POST",
      body: formData,
    })
      .then(() => {
        this.setState({ result: "success" })
      })
      .catch(error => this.setState({ result: "fail", msg: error }))
      .finally(() => {
        // Re-enable the submit button after the request completes
        this.setState({ isSubmitting: false })
      });
  }

  render() {

    let { resumes, cover_letters } = this.state

    let props = {
      ref: this.form,
      name: 'careers',
      className: 'form form--careers',
      onSubmit: this.handleSubmit,
    }

    if (this.state.result === "success")
      return (
        <div className='form'>
          <h4>Thanks for applying.</h4>
          <p>A member of our team will be in touch soon.</p>
        </div>
      )

    return (

      <form {...props}>

        <h4>Apply Now</h4>

        <div className='column_left'>

          { this.state.msg && <div className='error'>{ this.state.msg }</div> }

          <div className='form__row form__row--double'>

              <div>

                <label htmlFor='first-name-field'>First Name</label>

                <input type='text' name='firstname' id='first-name-field' className='form__input' onChange={this.handleChange} required />

              </div>

              <div>

                <label htmlFor='last-name-field'>Last Name</label>

                <input type='text' name='lastname' id='last-name-field' className='form__input' onChange={this.handleChange} required />

              </div>

          </div>
         
          <div className='form__row'>

            <label htmlFor='email-field'>Your Email</label>

            <input type='email' name='email' id='email-field' className='form__input' onChange={this.handleChange} required  />
    
          </div>

          <div className='form__row'>

            <label htmlFor='contact-field'>Contact Number</label>

            <input type='text' name='mobile' id='contact-field' className='form__input' onChange={this.handleChange} required  />

          </div>

          <div className='form__row'>

            <label htmlFor='position-field'>Position</label>

            <div className='form__select form__select--blue'>
              <Select
                options={this.jobs}
                onChange={this.handleSelectChange}
                openMenuOnFocus={true}
                id="position-field"
                name="position"
                placeholder="Please Select"
                className="react-select-container"
                classNamePrefix="react-select"
                ref={node => this.position = node}
              />
            </div>

          </div>

          <div className='form__row'>
            <label htmlFor='start-date-field'>Available start date</label>
            <input type='date' name='start_date' id='start-date-field' className='form__input' onChange={this.handleChange} required  />
          </div>

          <div className='form__row'>
            <label htmlFor='salary-field'>Salary Expectation</label>
            <input type='text' name='salary_expectation' id='salary-field' className='form__input' onChange={this.handleChange} required  />
          </div>

        </div>

        <div className='column_right'>

          <div className='form__row form__file'>
            <label htmlFor='resume-field'>Upload Resume</label>
            <Dropzone onDrop={this.onDropResume} multiple={false}>
              {({getRootProps, getInputProps}) => (
                <div  {...getRootProps({className: 'dropzone form__dropzone'})}>
                  <input name='resume' {...getInputProps()} />
                  <p>Drag and drop<br />
                  Or browse to choose a file</p>
                  { resumes.length === 0 && <span>.png, .jpg, .pdf accepted, up to 6MB</span> }
                  { resumes.length > 0 && resumes.map((file, i) =>
                    <div key={i}>{file.name} - {file.size} bytes</div>
                  )}
                </div>
              )}
            </Dropzone>
          </div>

          <div className='form__row form__file'>
            <label htmlFor='cover-letter-field'>Cover Letter</label>
            <Dropzone onDrop={this.onDropCover} multiple={false}>
              {({getRootProps, getInputProps}) => (
                <div  {...getRootProps({className: 'dropzone form__dropzone'})}>
                  <input name='cover_letter' {...getInputProps()} />
                  <p>Drag and drop<br />
                  Or browse to choose a file</p>
                  { cover_letters.length === 0 && <span>.png, .jpg, .pdf accepted, up to 6MB</span> }
                  { cover_letters.length > 0 && cover_letters.map((file, i) =>
                    <div key={i}>{file.name} - {file.size} bytes</div>
                  )}
                </div>
              )}
            </Dropzone>
          </div>

          <div className='form__row form__row--submit'>
            
            <button type='submit' className='btn btn--border' disabled={this.state.isSubmitting}>Apply Now</button>
          
          </div>

        </div>

      </form>
    )
  }
}

export default CareersForm